import { Modal } from 'shared/ui/Modal';
import { useModal } from 'shared/hooks/useModal';
import { modalData } from '../model/ModalData';

export const ModalWrapper = () => {
  const { modal, close } = useModal();

  return (
    <>
      {
        modalData.map((item) => (
          <Modal
            open={modal?.[item.id]?.visible}
            onCancel={() => close(item.id)}
            footer={item?.footer}
            key={item.id}
            width={item?.width}
            destroyOnClose={item?.destroyOnClose}
          >
            {item.content}
          </Modal>
        ))
      }
    </>

  );
};
